const env = {
  NODE_ENV: process.env.REACT_APP_NODE_ENV || "development",
  PORT: process.env.PORT || 3000,
  SOCKET_BASE_URL:
    process.env.REACT_APP_SOCKET_BASE_URL || "http://localhost:4000",
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api/v1/",
  STRIPE_KEY:
    process.env.REACT_APP_STRIPE_KEY ||
    "pk_test_51HpdUIL8TihLg2qB3gMjNvQNOZBxtQ3nwIVlamg6xES59LKqBi018qToWs6BMd6IzyOk1kCfnsWiEY0W9ma4fmgx00yYZUu202",
  STRIPE_TEST_KEY:
    "pk_test_51HpdUIL8TihLg2qB3gMjNvQNOZBxtQ3nwIVlamg6xES59LKqBi018qToWs6BMd6IzyOk1kCfnsWiEY0W9ma4fmgx00yYZUu202",
  STRIPE_LIVE_KEY:
    "pk_live_51HpdUIL8TihLg2qBb2h1ihFV2DWsFyU8b9pJc218hKJxltKj06q57yWuhJyPA2uzRXDWquDIWXD2aT2zx6FXlmek00kPEDXPMx",
  STRIPE_TEST_PRODUCT: "price_1JKNcTL8TihLg2qBfUDiPdXZ",
  STRIPE_LIVE_PRODUCT: "price_1Jh95hL8TihLg2qBe69ZGRlu",
  MOSTAZA_SERVICES_APITOKEN:
    process.env.REACT_APP_MOSTAZA_SERVICES_APITOKEN || "",
  WEBAPP_BASE_URL:
    process.env.REACT_APP_WEBAPP_BASE_URL || "http://localhost:3000",
  ZOOM_JWT_API_KEY: process.env.REACT_APP_ZOOM_JWT_API_KEY || "",
  GA_TRACKING_CODE: process.env.REACT_APP_GA_TRACKING_CODE || "",
  FB_TRACKING_CODE: process.env.REACT_APP_FB_TRACKING_CODE || "",
};

export default env;
